<!-- /src/components/common/BackButton.vue -->
<template>
  <button
    v-if="hasHistory"
    class="button button--sm button--go-back button--brandPrimary"
    :class="[{'button--withIcon button--medium': isTablet || isDesktop}]"
    @click="goBack"
  >
    <span class="button__icon">
      <i class="fal fa-angle-double-left"></i>
    </span><span v-if="isTablet || isDesktop" class="button__text">Back</span>
  </button>
</template>

<script>
import resizeMixin from '@/mixins/resizeMixin'

export default {
  data() {
    return {}
  },

  mixins: [resizeMixin],

  props: {
    text: {
      type: String,
      required: false,
    },
    classes: {
      type: String,
      required: false,
    },
    routePath: {
      type: [String, Object],
      required: false,
    },
  },

  computed: {
    hasHistory() {
      return this.$store.getters['getRouteHistory'][1] ? true : false
    },

    goBackText() {
      const routeHistory = this.$store.getters['getRouteHistory']
      if (this.text) {
        return this.text
      } else if (routeHistory[1]) {
        return 'Back to ' + routeHistory[1].meta.title
      }
      return 'Back'
    },

    path() {
      const routeHistory = this.$store.getters['getRouteHistory']
      if (this.routePath) {
        return this.routePath
      } else if (routeHistory[1]) {
        return routeHistory[1].fullPath
      }
      return false
    },
  },

  methods: {
    goBack() {
      this.$store.dispatch('isBackButtonClicked', true)
      this.$router.push(this.path)
    },
  },

  mounted() {
    // console.log(this.$router)
  },
}
</script>

<style scoped>
/* .button--go-back {
        cursor
    } */
.back-button {
  width: 100%;
  margin-bottom: 1rem;
  button {
    width: 100%;
  }
}
</style>
